import keyMirror from "ramda-extension/es/keyMirror";
export const ALL_FIELDS = 'allFields';
export const validationDisplayTypes = keyMirror({
    TOOLTIP: null,
    PLAIN_TEXT: null,
    HIDDEN: null,
    NONE: null
});
export const HIDDEN_HELPER_TEXT = [
    validationDisplayTypes.TOOLTIP,
    validationDisplayTypes.HIDDEN,
    validationDisplayTypes.NONE
];
